import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Shared axios instance — sends the lrs_session cookie on every call. */
export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});
